module.exports = __webpack_public_path__ + "img/room11.19ff1c9e.gif";